import { render, staticRenderFns } from "./UcContractGeneralInfo.yaml?vue&type=template&id=75c25946&component"
import script from "./UcContractGeneralInfo.yaml?vue&type=script&lang=ts&component"
export * from "./UcContractGeneralInfo.yaml?vue&type=script&lang=ts&component"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports